var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M21.387 21.387a.867.867 0 0 1-1.226 0l-6.693-6.693a6.7 6.7 0 0 1-2.007 1.127 6.9 6.9 0 0 1-2.347.407q-2.982 0-5.048-2.065T2 9.116t2.065-5.049Q6.131 2 9.112 2q2.982 0 5.05 2.066 2.066 2.066 2.066 5.048 0 1.246-.418 2.38a6.7 6.7 0 0 1-1.117 1.974l6.694 6.693a.867.867 0 0 1 0 1.226M9.114 14.483q2.249 0 3.809-1.56t1.56-3.809-1.56-3.809q-1.56-1.56-3.809-1.56t-3.809 1.56-1.56 3.81 1.56 3.808 3.81 1.56"
  })));
};
export default SvgSearch;